import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { AngularSplitModule } from 'angular-split';
import { DirectivesModule } from '../../directives/directives.module';
import { CustomFormsModule } from '../custom-forms/custom-forms.module';
import { ComponentsModule } from '../../components/components.module';
import { HandlesDialogComponent } from './handles-dialog.component';
import { HandlesDialogService } from './handles-dialog.service';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
  imports: [
    FuseSharedModule,
    CustomFormsModule,
    AngularSplitModule,

    DirectivesModule,
    ComponentsModule,

    MatIconModule, //
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDialogModule,
    MatSortModule,
    MatRippleModule,
    MatDividerModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
  ],
  declarations: [HandlesDialogComponent],
  providers: [
    {
      provide: HandlesDialogService,
      useClass: CuttingButtFormService,
    },
  ],
  exports: [CustomFormsModule, HandlesDialogComponent],
})
export class HandlesDialogModule {}
